import React from "react";
import { motion } from "framer-motion";

const lines = [
    "Tarafsız analiz.",
    "Özgün yayın.",
    "Sporun dijital nabzı.",
];

export default function EditorialStatement() {
    return (
        <section className="relative overflow-hidden border-y border-[var(--line)] bg-[var(--ink)] text-white">
            <div
                className="pointer-events-none absolute inset-0 opacity-[0.07]"
                style={{
                    backgroundImage:
                        "radial-gradient(circle at 20% 20%, #af2122 0%, transparent 45%), radial-gradient(circle at 80% 80%, #ffffff 0%, transparent 40%)",
                }}
            />
            <div className="relative w-11/12 max-w-7xl mx-auto py-20 md:py-28">
                <motion.p
                    initial={{ opacity: 0, y: 12 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.5 }}
                    className="text-xs uppercase tracking-[0.25em] text-white/55 mb-8"
                >
                    Sports Digitale
                </motion.p>
                <div className="space-y-2 md:space-y-3">
                    {lines.map((line, i) => (
                        <motion.h2
                            key={line}
                            initial={{ opacity: 0, y: 28 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.55, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                            className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[1.05]"
                        >
                            {line}
                        </motion.h2>
                    ))}
                </div>
                <motion.div
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="mt-10 h-px w-24 origin-left bg-[var(--accent)]"
                />
            </div>
        </section>
    );
}
